import { render, staticRenderFns } from "./CreateDemand.vue?vue&type=template&id=4a777b54&scoped=true&"
import script from "./CreateDemand.vue?vue&type=script&lang=js&"
export * from "./CreateDemand.vue?vue&type=script&lang=js&"
import style0 from "./CreateDemand.vue?vue&type=style&index=0&id=4a777b54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a777b54",
  null
  
)

export default component.exports